
<template>
    <div class="grid flex justify-content-center ">
                        <div class="col-12 md:col-6 sm:12 md:mx-auto">
                            <div class="surface-section px-4 py-2 md:px-6 lg:px-8 border-round">
                                <Card class="scalein  animation-duration-500">
                                  <template #title>
                                    <Tag :class="GetTagInfo().Color" class="mr-2"> {{GetTagInfo().Name}}</Tag>  Step 2 (Select Pricing Tier)
                                  </template>
                                    <template #content>
                                      <div class="overflow-x-auto">
                                        <div class="w-full">
                                          <div class="text-900 text-xl mb-3 text-left font-medium">
                                            Select Pricing Tier</div>
                                            <div class="surface-border border-1 p-3 border-round-top flex align-items-center cursor-pointer" :class="{'surface-card': SelectedPayment !== item, 'bg-bluegray-100': SelectedPayment === item}" @click="SelectedPayment = item" v-for="(item, index) in Payments" :key="index">
                                              <div class="w-12 flex align-items-center pr-4">

                                                <div class="font-medium" :class="{'text-900': item !== SelectedPayment, 'bg-bluegray-100': SelectedPayment === item}">{{item.price}}  <Tag :class="GetPricingLabel(item).class">{{GetPricingLabel(item).label}}</Tag></div>
                                              </div>
                                              <!--<div class="w-4 text-center">
      <span class="bg-blue-100 text-blue-700 font-medium px-2 py-1" style="border-radius:12px">Save 20%</span>
    </div>-->
                                              <div class="w-6 text-right">
                                                <RadioButton name="item" :value="item" v-model="SelectedPayment" class="mr-2"></RadioButton>
                                              </div>
                                            </div>
                                          </div>
                                      </div>
                                    </template>
                                    <template #footer>
                                      <div class="col-12">
                                        <span class="p-buttonset ml-0 pl-0">
                                          <Button label="Cancel" icon="pi pi-ban" style="width:50%" class="surface-800 border-surface-700" @click="Cancel" />
                                          <Button label="Subscribe" icon="pi pi-arrow-circle-right" iconPos="right" style="width:50%" class="bg-orange-700 border-orange-700" :disabled="SelectedPayment == null" @click="NextPage()"/>
                                        </span>
                                      </div>
                                    </template>
                                </Card>
                            </div>
                        </div>
            </div>
</template>


<style>
    .p-inputwrapper {
        width: 100% !important;
    }

    .p-badge.p-badge-warning {
        background-color: #d98100;
        color: white;
    }

  .p-radiobutton .p-radiobutton-box.p-highlight {
    border-color: #e1c3ae;
    background: #ae510f;
  }
</style>

<script>

    import Card from 'primevue/card';
  import Button from 'primevue/button';
  import Tag from 'primevue/tag';
  import RadioButton from 'primevue/radiobutton';
    //import Splitter from 'primevue/splitter';
    //import SplitterPanel from 'primevue/splitterpanel';
    //import Password from 'primevue/password';
    //import RadioButton from 'primevue/radiobutton';
    //import Divider from 'primevue/divider';

    export default {
        name: 'StepTwo',
        props: ['GroupPrices', 'PaymentLinks', 'Products', 'StripeCustomerId','ProductId'],
        components: {
            Card,
          Button,
            Tag,
            //Splitter,
            //SplitterPanel,
            //Password,
            RadioButton,
            //Divider,
        },
        data: () => ({
            checkbox: true,
            overlay: true,
            SelectedPayment: null,
            Payments:'',
            User: {
                FirstName: '',
                LastName: '',
                Email: '',
                Password: ''
          },
          ProductDescriptions: [
            { Id: 'prod_MuFadGEwLEUWri', Color: 'bg-bluegray-700', Name: 'Essential' },
            { Id: 'prod_MuFcIDe6b2zTFs', Color: 'bg-blue-700', Name: 'Elite' },
            { Id: 'prod_MuFhtvENLZsV4t', Color: 'bg-orange-600', Name: 'Elite + VIP' }
          ],
    }),
    created() {
      this.Payments = this.$props.PaymentLinks
    },
    methods: {
      GetTagInfo() {
        var getProduct = this.ProductDescriptions.filter(c => c.Id == this.$props.ProductId)[0]
        return getProduct;
      },
      GetPricingLabel(item) {
        var descObj = {label: "Monthly", class:'bg-orange-700 ml-2'}

        if (item.description != null) {
          descObj.label = item.description
          descObj.class = "bg-blue-700 ml-2"
        }

        return descObj;
      },
      Cancel() {
        this.$router.push('/')
      },
      NextPage() {
        window.location.href = this.SelectedPayment.paymentLinkUrl;
        }
      }
    }
</script>